import React from "react";
import { associatedLine } from "../situation.mjs";

/*
 * ASSOCIATED CONTACT: a pointer to the point of contact, then the company's record
 * (frame 1i: "Associated at Pluto · point of contact Shahar Bahat →", "The company’s
 * record follows below."). The arrow opens the point of contact in the same panel,
 * with "← {company}" back (the shell's person stack). LeadBlock renders the
 * company's own lead block under this one, and the shell the company's Next, story
 * and rail, with People open (their place at the company is the question).
 *
 * Props:
 *   record   the shell's bundle: company (poc, contacts), view.situation
 *            (company_situation: what follows below)
 *   ops      ops.openPerson(contactId)
 */
export default function AssociatedPointer({ record, ops }) {
  const a = associatedLine(record.company);
  const follows = record.view.situation.company_situation && record.view.situation.company_situation !== "out";
  return (
    <section className="rec-card rec-card--tight rec-lead rec-lead--out" aria-label="Associated contact">
      <div>
        {a.text} · point of contact{" "}
        {a.poc_id ? (
          <button type="button" className="rec-link rec-link--plain rec-lead__poc" onClick={() => ops.openPerson(a.poc_id)}>
            {a.poc_name} →
          </button>
        ) : (
          <span className="rec-sub">not set</span>
        )}
        {follows && <div className="rec-sub">The company’s record follows below.</div>}
      </div>
    </section>
  );
}
